<template>
  <div
    id=""
    :class="{ nonChromeBrowserFix: !isChrome }"
  >
    <transition-group
      :name="$store.state.display.messages.balloonsTransitionName"
      appear
      tag="div"
      mode="out-in"
    >
      <div class="invisibleIntersect" :key="'intersectContainer'" v-if="isMoreAvailable" v-waypoint="waypointOptions" />
      <StarredMessageBalloon
        v-for="(message, index) in $store.getters.starredMessagesList"
        :key="message.MessageID"
        :message="message"
        :index="index"
        :ref="message.MessageID"
        @click="goToMessage"
      />
    </transition-group>
  </div>
</template>

<script>
import StarredMessageBalloon from './StarredMessageBalloon.vue'
import EventBus from '@/eventbus.js'
import { setTimeout } from 'timers'
export default {
  components: {
    StarredMessageBalloon
  },

  data () {
    return {
      waypointOptions: {
        active: true,
        callback: this.onWaypoint,
        options: {
          root: null,
          rootMargin: '0px 0px 0px 0px',
          threshold: [0, 0.2]
        }
      },
      prevHeight: 0
    }
  },

  computed: {
    isChrome () {
      let ag = window.navigator.userAgent
      if (ag.toLowerCase().includes('Chrome'.toLowerCase())) {
        return true
      }
      return false
    },
    isMoreAvailable () {
      return this.$store.getters.starredMessagesList.length < this.$store.getters.activeConversationMessages.length
    },
    pagedConv () {
      return this.$store.getters.starredMessagesList
    }
  },

  methods: {
    goToMessage () {

    },
    onWaypoint (waypoint) {
      if (waypoint.going === 'in') {
        var scrollObject = document.getElementById('messagesMainContainer')
        this.prevHeight = scrollObject.scrollHeight
        this.$store.commit('incrementConversationPage')
      }
    },
    scrollToBottom () {
      setTimeout(() => {
        var scrollObject = document.getElementById('messagesMainContainer')
        scrollObject.scrollTop = scrollObject.scrollHeight
      }, 0.1 * 1000)
    },
    adjustHeight () {
      var scrollObject = document.getElementById('messagesMainContainer')
      var heightDiff = scrollObject.scrollHeight - this.prevHeight
      scrollObject.scrollTop += heightDiff
    },
    scrollToReply (MessageID) {
      var refToScroll = this.$refs[MessageID][0]
      refToScroll.$el.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      })
      // TO-DO: Animate the message box
    }
  },

  mounted () {
    EventBus.$on('scrollToBottom', this.scrollToBottom)
    EventBus.$on('scrollToReply', this.scrollToReply)
  },

  beforeDestroy () {
    EventBus.$off('scrollToBottom')
    EventBus.$off('scrollToReply')
  },

  watch: {
    pagedConv () {
      if (this.$store.state.conversation.conversationPage !== 1) {
        setTimeout(() => { this.adjustHeight() }, 0.00001 * 1000)
      }
    }
  }
}
</script>

<style scoped>
#messagesMainContainer {
  background: url("../../../../assets/images/bg2.png");
  background-repeat: repeat;
  background-size: 206px 412px;
  flex-grow: 1;
  display: flex;
  flex-direction: column-reverse;
  overflow-x: hidden;
  overflow-y: scroll;
  padding-bottom: 20px;
}

.nonChromeBrowserFix {
  flex-direction: column !important;
}

#messagesMainContainer::-webkit-scrollbar {
    width: 2px;
}

#messagesMainContainer::-webkit-scrollbar-thumb {
    background-color: rgb(155, 155, 155);
}

.invisibleIntersect {
  height: 20px;
}
</style>
